import React from "react"
import Helmet from "react-helmet"

const Index = ({ index = false, name = "", description, slug = "" }) => {
  return (
    <Helmet>
      <title>{`${name} | Shop @ Mechanical Air Conditioning`}</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" lang="en-US" content={description} />
      <meta
        property="og:title"
        content={`${name} | Mechanical Air Conditioning`}
      />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`https://shop.mechanicalac.com/${slug}`}
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="Shop @ mechanicalac.com" />
      <meta
        property="og:image"
        content="https://tjpc.com/img/mechac-logo.png"
      />
      <meta name="geo.region" content="US-FL" />
      <link rel="canonical" href={`https://shop.mechanicalac.com/${slug}`} />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href="https://tjpc.com/img/icons/apple-touch-icon-76x76.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="https://tjpc.com/img/icons/apple-touch-icon-120x120.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="https://tjpc.com/img/icons/apple-touch-icon-152x152.png"
      />
    </Helmet>
  )
}

export default Index
